<template>
<div>
  <div v-if="hasAuth">
    <el-row :gutter="4" style="margin-bottom:4px;">
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo" />
      </el-col>
      <el-col :span="12">
        <w-netinterface-control-popup-button :obj-info="objInfo" />
      </el-col>
    </el-row>
    <el-row :gutter="4" class="mr-b25">
      <el-col :span="12">
        <w-collection-judgement-rule-popup-button :obj-info="objInfo"></w-collection-judgement-rule-popup-button>
      </el-col>
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth"></w-event-alarm-rule-popup-button>
      </el-col>
    </el-row>
    <w-basic-sliding-button-group :obj-info="objInfo" />
  </div>
  <div v-else>
    <el-row :gutter="4">
      <el-col :span="12">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo" />
      </el-col>
      <el-col :span="12">
        <w-event-alarm-rule-popup-button :obj-info="objInfo" :has-auth="hasAuth" />
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import WBasicSlidingButtonGroup from './BasicSlidingButtonGroup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WNetinterfaceControlPopupButton from './NetinterfaceControlPopupButton';
import WCollectionJudgementRulePopupButton from './CollectionJudgementRulePopupButton';
import WEventAlarmRulePopupButton from './EventAlarmRulePopupButton';

export default {
  name: 'WNetinterfaceSlidingButtonGroup',
  components: {
    WBasicSlidingButtonGroup,
    WCommonSettingChartTypePopupButton,
    WNetinterfaceControlPopupButton,
    WCollectionJudgementRulePopupButton,
    WEventAlarmRulePopupButton,
  },
  mixins: [HambugerPopupMixin],
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/NetinterfaceSlidingButtonGroup.vue